import { render, staticRenderFns } from "./SmileID.vue?vue&type=template&id=bc1db2fe&"
import script from "./SmileID.vue?vue&type=script&lang=js&"
export * from "./SmileID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports